<!--投資組合详情-->
<template>
	<div class="page-body center-wrap">
		<titleModel></titleModel>

		<div class="xb-box">
			<div class="back-con" @click="$nav.back()">
				<i class="el-icon-arrow-left"></i>
				<span>{{ $t('返回上一页') }}</span>
			</div>

			<div class="portfolio-trade-page">
				<h3 class="title">{{ invest }}</h3>
				<section class="card card-1">
					<div class="cm-card-title">
						<i class="icon-square-1"></i>
						<span class="text fade-in-right">{{ $t('认购组合') }}</span>
					</div>
					<div class="scroll-wrap">
						<ul class="list">
							<li class="item-currency" v-for="item in rowList" :key="item.id">
								<img alt="" :src="item.image" class="lazy-img logo">
								<div class="name-area">
									<div>{{ item.symbol }}</div>
									<div :style="{ color: item.price_zf > 0 ? '#00f0e0' : '#ff341f' }">
										{{ item.price_zf > 0 ? '+' + item.price_zf : item.price_zf }}
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="rtuhrh">
						<div class="row row-title">
							<span class="column">{{ $t('运行时长') }}</span>
							<span class="column">{{ $t('日收益率') }}</span>
							<span class="column">{{ $t('预估收益') }}</span>
							<span class="column flex-2">{{ $t('投资金额') }}</span>
							<span class="column">{{ $t('手续费') }}</span>
						</div>
						<div class="row">
							<span class="column">{{ info.days }}{{ $t('天') }}</span>
							<span class="column">{{ info.ratemax }}%</span>
							<span class="column">
								<span>{{ estimate }}</span>
								<div class="svg-container svg-img white">
									<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
										class="svg-class">
										<g id="Frame">
											<path id="Vector"
												d="M12.4986 4.79406V2.60156H3.52177V4.79406H6.83125V6.22648C4.14102 6.34747 2.11523 6.87778 2.11523 7.51405C2.11523 8.15033 4.141 8.68061 6.83125 8.80161V13.3987H9.18916V8.80053C11.869 8.67772 13.8845 8.14838 13.8845 7.51403C13.8845 6.87961 11.869 6.35009 9.18916 6.22744V4.79405H12.4986V4.79406ZM12.871 7.38452C12.871 7.80298 11.3046 8.154 9.18916 8.25145L9.05245 8.25725H9.03734L8.90916 8.26197H8.89528C8.79994 8.26523 8.70344 8.26803 8.60572 8.27023H8.59966L8.46858 8.27295H8.43153L8.32809 8.27434H7.67305L7.57067 8.27295H7.53511L7.41281 8.27039H7.39937C7.25442 8.26716 7.11166 8.26269 6.971 8.25725H6.96916L6.82912 8.25119C4.70317 8.15522 3.12666 7.80298 3.12666 7.38252C3.12666 6.96195 4.70344 6.61077 6.82912 6.51373V7.84353C7.19814 7.86277 7.59069 7.87331 7.99781 7.87331C8.41142 7.87331 8.81189 7.86259 9.18712 7.84247V6.51769C11.3044 6.61489 12.871 6.96608 12.871 7.38452Z">
											</path>
										</g>
									</svg>
								</div>
							</span>
							<span class="column flex-2">
								<span>{{ info.amount }} - {{ info.amax }}</span>
								<div class="svg-container svg-img white">
									<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
										class="svg-class">
										<g id="Frame">
											<path id="Vector"
												d="M12.4986 4.79406V2.60156H3.52177V4.79406H6.83125V6.22648C4.14102 6.34747 2.11523 6.87778 2.11523 7.51405C2.11523 8.15033 4.141 8.68061 6.83125 8.80161V13.3987H9.18916V8.80053C11.869 8.67772 13.8845 8.14838 13.8845 7.51403C13.8845 6.87961 11.869 6.35009 9.18916 6.22744V4.79405H12.4986V4.79406ZM12.871 7.38452C12.871 7.80298 11.3046 8.154 9.18916 8.25145L9.05245 8.25725H9.03734L8.90916 8.26197H8.89528C8.79994 8.26523 8.70344 8.26803 8.60572 8.27023H8.59966L8.46858 8.27295H8.43153L8.32809 8.27434H7.67305L7.57067 8.27295H7.53511L7.41281 8.27039H7.39937C7.25442 8.26716 7.11166 8.26269 6.971 8.25725H6.96916L6.82912 8.25119C4.70317 8.15522 3.12666 7.80298 3.12666 7.38252C3.12666 6.96195 4.70344 6.61077 6.82912 6.51373V7.84353C7.19814 7.86277 7.59069 7.87331 7.99781 7.87331C8.41142 7.87331 8.81189 7.86259 9.18712 7.84247V6.51769C11.3044 6.61489 12.871 6.96608 12.871 7.38452Z">
											</path>
										</g>
									</svg>
								</div>
							</span>
							<span class="column">
								<span>{{ info.commission }}</span>
								<div class="svg-container svg-img white">
									<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
										class="svg-class">
										<g id="Frame">
											<path id="Vector"
												d="M12.4986 4.79406V2.60156H3.52177V4.79406H6.83125V6.22648C4.14102 6.34747 2.11523 6.87778 2.11523 7.51405C2.11523 8.15033 4.141 8.68061 6.83125 8.80161V13.3987H9.18916V8.80053C11.869 8.67772 13.8845 8.14838 13.8845 7.51403C13.8845 6.87961 11.869 6.35009 9.18916 6.22744V4.79405H12.4986V4.79406ZM12.871 7.38452C12.871 7.80298 11.3046 8.154 9.18916 8.25145L9.05245 8.25725H9.03734L8.90916 8.26197H8.89528C8.79994 8.26523 8.70344 8.26803 8.60572 8.27023H8.59966L8.46858 8.27295H8.43153L8.32809 8.27434H7.67305L7.57067 8.27295H7.53511L7.41281 8.27039H7.39937C7.25442 8.26716 7.11166 8.26269 6.971 8.25725H6.96916L6.82912 8.25119C4.70317 8.15522 3.12666 7.80298 3.12666 7.38252C3.12666 6.96195 4.70344 6.61077 6.82912 6.51373V7.84353C7.19814 7.86277 7.59069 7.87331 7.99781 7.87331C8.41142 7.87331 8.81189 7.86259 9.18712 7.84247V6.51769C11.3044 6.61489 12.871 6.96608 12.871 7.38452Z">
											</path>
										</g>
									</svg>
								</div>
							</span>
						</div>
					</div>
				</section>
				<section class="card card-2">
					<div class="cm-card-title">
						<i class="icon-square-1"></i>
						<span class="text fade-in-right">{{ $t('申购金额') }}</span>
					</div>
					<div class="cm-input-box-pc">
						<button class="minus-btn" @click="del"><img src="@/assets/img-pc/57.f4296461.svg"></button>
						<el-input v-model="form.amount" type="number" :placeholder="$t('请输入投资金额')" />
						<div class="svg-container svg-img mr20 white">
							<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
								class="svg-class">
								<g id="Frame">
									<path id="Vector"
										d="M12.4986 4.79406V2.60156H3.52177V4.79406H6.83125V6.22648C4.14102 6.34747 2.11523 6.87778 2.11523 7.51405C2.11523 8.15033 4.141 8.68061 6.83125 8.80161V13.3987H9.18916V8.80053C11.869 8.67772 13.8845 8.14838 13.8845 7.51403C13.8845 6.87961 11.869 6.35009 9.18916 6.22744V4.79405H12.4986V4.79406ZM12.871 7.38452C12.871 7.80298 11.3046 8.154 9.18916 8.25145L9.05245 8.25725H9.03734L8.90916 8.26197H8.89528C8.79994 8.26523 8.70344 8.26803 8.60572 8.27023H8.59966L8.46858 8.27295H8.43153L8.32809 8.27434H7.67305L7.57067 8.27295H7.53511L7.41281 8.27039H7.39937C7.25442 8.26716 7.11166 8.26269 6.971 8.25725H6.96916L6.82912 8.25119C4.70317 8.15522 3.12666 7.80298 3.12666 7.38252C3.12666 6.96195 4.70344 6.61077 6.82912 6.51373V7.84353C7.19814 7.86277 7.59069 7.87331 7.99781 7.87331C8.41142 7.87331 8.81189 7.86259 9.18712 7.84247V6.51769C11.3044 6.61489 12.871 6.96608 12.871 7.38452Z">
									</path>
								</g>
							</svg>
						</div>
						<button class="plus-btn" @click="add"><img src="@/assets/img-pc/58.ba46ca0f.svg"></button>
					</div>
					<div class="row-2">
						<span class="label2">{{ $t('账户余额') }}：</span>
						<span>{{ Number(info.earn_account) || '0.00' }}</span>
						<div class="svg-container svg-img white">
							<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
								class="svg-class">
								<g id="Frame">
									<path id="Vector"
										d="M12.4986 4.79406V2.60156H3.52177V4.79406H6.83125V6.22648C4.14102 6.34747 2.11523 6.87778 2.11523 7.51405C2.11523 8.15033 4.141 8.68061 6.83125 8.80161V13.3987H9.18916V8.80053C11.869 8.67772 13.8845 8.14838 13.8845 7.51403C13.8845 6.87961 11.869 6.35009 9.18916 6.22744V4.79405H12.4986V4.79406ZM12.871 7.38452C12.871 7.80298 11.3046 8.154 9.18916 8.25145L9.05245 8.25725H9.03734L8.90916 8.26197H8.89528C8.79994 8.26523 8.70344 8.26803 8.60572 8.27023H8.59966L8.46858 8.27295H8.43153L8.32809 8.27434H7.67305L7.57067 8.27295H7.53511L7.41281 8.27039H7.39937C7.25442 8.26716 7.11166 8.26269 6.971 8.25725H6.96916L6.82912 8.25119C4.70317 8.15522 3.12666 7.80298 3.12666 7.38252C3.12666 6.96195 4.70344 6.61077 6.82912 6.51373V7.84353C7.19814 7.86277 7.59069 7.87331 7.99781 7.87331C8.41142 7.87331 8.81189 7.86259 9.18712 7.84247V6.51769C11.3044 6.61489 12.871 6.96608 12.871 7.38452Z">
									</path>
								</g>
							</svg>
						</div>
					</div>
					<button class="buy-btn hand cur-poi" @click="submit">{{ $t('申购') }}</button>
				</section>
				<div class="cm-card-title">
					<i class="icon-square-1"></i>
					<span class="text">{{ richText.title }}</span>
				</div>
				<p class="p1" v-html="richText.content"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { get, post } from '@/http/request'
import { getQueryParam } from '@/common/public.js';
import titleModel from './components/title.vue';
export default {
	components: {
		titleModel,
	},
	data() {
		return {
			form: {
				amount: '',
				id: getQueryParam('id'),
			},
			invest: getQueryParam('invest'),
			info: {},
		};
	},
	mounted() {
		this.combineInfo()
	},
	computed: {
		rowList() {
			return this.info.product_list || []
		},
		richText() {
			return this.info.rich_text || {}
		},
		//预估收益
		estimate() {
			return (Number(this.form.amount) * Number(this.info.ratemax) * Number(this.info.days)).toFixed(2)
		},
	},
	methods: {
		add() {
			this.form.amount += '1'
		},
		del() {
			if (this.form.amount) {
				this.form.amount = String(this.form.amount).slice(0, -1)
			}
		},
		combineInfo() {
			get(this.$apis.getQuantCombineInfo, { id: this.form.id }).then(res => {
				if (res.code != 1) return
				this.info = res.data
			})
		},
		submit() {
			post(this.$apis.quantOrderSubmit, this.form).then(res => {
				if (res.code != 1) return
				this.form.amount = ''
				this.$notify.success(res.msg)
				this.combineInfo()
			})
		}
	},
};
</script>
<style lang="scss" scoped>
.xb-box {
	position: relative;

	.portfolio-trade-page {
		width: 700px;
		margin: 20px auto;
		padding: 20px;
		border-radius: 12px;
		background: #1f1f2f;
		position: relative;
		color: #fff;

		.card {
			&.card-2 {
				margin-top: 50px;

				.buy-btn {
					width: 100%;
					height: 60px;
					background: #00f0ff;
					color: #000;
					line-height: 60px;
					border-radius: 100px;
					margin: 0 auto;
					margin-bottom: 80px;
					border-width: 0;
				}

				.row-2 {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					justify-content: normal;
					margin-bottom: 20px;
					line-height: 22px;
					text-align: left;

					.label2 {
						color: #888;
					}

					.svg-img {
						// margin-top: 0;
					}
				}
			}

			.cm-card-title {
				font-size: 16px;
				padding: 0;
			}

			.cm-input-box-pc {
				position: relative;
				border-radius: 6px;
				background: #000;
				border: 1px solid #2c2c3e;
				color: #888;
				padding: 0 20px;
				width: 100%;
				height: 44px;
				margin: 0 auto;
				display: flex;
				flex-wrap: nowrap;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				height: 60px;
				margin-bottom: 30px;

				button {
					flex: none;
					width: 40px;
					height: 40px;
					border-radius: 5px;
					background: #1a1b24;
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					border-width: 0;
				}

				.svg-img {
					margin: 10px 15px;
				}

				::v-deep .el-input__inner {
					border: none;
					box-shadow: none;
					font-size: 16px;
				}
			}

			.rtuhrh {
				.row {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					justify-content: normal;
					font-weight: 500;
					font-size: 14px;
					height: 60px;
					border-bottom: 1px solid #31323f;

					&.row-title {
						color: #888;
					}
				}

				.column {
					flex: 1;
					text-align: center;
					display: flex;
					align-items: center;
					flex-direction: row;
					justify-content: center;
				}
			}

			.scroll-wrap {
				width: 100%;
				overflow-x: auto;
				overflow-y: hidden;
				margin-bottom: 20px;

				.list {
					width: 100%;
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					justify-content: normal;

					.item-currency {
						flex: none;
						width: 190px;
						height: 86px;
						background: #2c2c3e;
						border-radius: 8px;
						padding: 16px 9px;
						margin-right: 14px;
						display: flex;
						flex-wrap: nowrap;
						flex-direction: row;
						align-items: normal;
						justify-content: normal;

						.logo {
							flex: none;
							display: inline-block;
							width: 46px;
							height: 46px;
							margin-bottom: 14px;
							background-color: #2c2c3e;
							border-radius: 50%;

						}

						.name-area {
							font-size: 14px;
							margin-left: 10px;
						}
					}
				}
			}
		}

		>.title {
			margin: 20px 0;
			text-align: center;
			font-size: 24px;
		}
	}

	.p1 {
		color: #888;
		font-size: 13px;
		padding: 0 12px;
		margin: 0;
		line-height: 25px;
	}

	.cm-card-title {
		width: 100%;
		height: 24px;
		margin-bottom: 15px;
		padding: 0 12px;
		font-size: 20px;

		.icon-square-1 {
			display: inline-block;
			width: 8px;
			height: 8px;
			border-radius: 2px;
			background: #00f0ff;
			margin-right: 5px;
			color: #000;
		}

		.text {
			height: 24px;
			line-height: 24px;
			margin-right: auto;
			color: #fff;
		}
	}

	.back-con {
		position: absolute;
		top: 0;
		left: 0;
		font-size: 14px;
		cursor: pointer;
	}

	.svg-img {
		margin-top: 4px;
		margin-left: 4px;
	}
}
</style>